import script from "./InfoCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfoCard.vue?vue&type=script&setup=true&lang=ts"

import "./InfoCard.vue?vue&type=style&index=0&id=6217d520&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6217d520"]])

export default __exports__